/**
 * Sentinel values for custom education slides.
 *
 * These are kept in a separate file to avoid circular dependencies
 * between Education.constants.ts and slideIdentifier.utils.ts.
 */

/**
 * Sentinel value for a draft (new) custom education slide that hasn't been saved yet.
 */
export const DRAFT_SLIDE_ID = 'DRAFT' as const;

/**
 * Prefix for custom education slide identifiers.
 * Custom slides are identified by this prefix followed by a timestamp and random string.
 * Example: CUSTOM_PAGE_1734567890123_abc123
 */
export const CUSTOM_SLIDE_PREFIX = 'CUSTOM_PAGE_' as const;

/**
 * Type for the draft slide ID literal.
 */
export type DraftSlideId = typeof DRAFT_SLIDE_ID;
